import React, { memo } from 'react';
import './Filters.css';
import { useIgdFiltersContext } from './hooks/useIgdFiltersContext';
import PeriodIndicator from '../../../Common/Filters/PeriodIndicator';
import MultipleSelect from '../../../Common/Filters/MultipleSelect';
import { getMonthsByYear } from '../../../Common/Util/getMonthsByYear';
import { getYearsDescending } from '../../../Common/Util/getYearsDescending';
const IgdFilters = ({ className = '' }) => {
    const { filters, onFilterChange } = useIgdFiltersContext();

    const selectedYear = filters.year?.value || '';
    const years = getYearsDescending();
    const monthsReferenceYear = selectedYear || '2025';
    const isYearAllSelected = filters.year?.value === '';
    const isMonthAllSelected = filters.month?.value === '';

    const monthOptions = [
        { value: '', label: 'Todos' },
        ...getMonthsByYear(monthsReferenceYear, true).map((month, index) => ({
            value: `${index + 1}`.padStart(2, '0'),
            label: month
        }))
    ];

    const yearOptions = [
        { value: '', label: 'Todos' },
        ...years
            .map((year) => ({
                value: year,
                label: year
            }))
            .reverse()
    ];

    return (
        <>
            <PeriodIndicator filters={filters} />

            <div className={`filtros-container-dashboards ${className}`}>
                <MultipleSelect
                    label="Ano"
                    options={yearOptions}
                    onChange={onFilterChange}
                    name="year"
                    defaultValue={filters.year}
                    className="select-ano-dashboards"
                    isOptionDisabled={(option) => option.value === '' && isMonthAllSelected}
                />

                <MultipleSelect
                    label="Mês"
                    options={monthOptions}
                    onChange={onFilterChange}
                    name="month"
                    defaultValue={filters.month}
                    className="select-competencia-dashboards"
                    isOptionDisabled={(option) => option.value === '' && isYearAllSelected}
                />
            </div>
        </>
    );
};

export default memo(IgdFilters);
